import { useLocale } from "@/contexts/LanguageContext";

const stats = [
  { value: "4.9★", label: { en: "Google Reviews", es: "Reseñas de Google" } },
  { value: "1,500+", label: { en: "Clients Helped", es: "Clientes Atendidos" } },
  { value: "235+", label: { en: "Insurance Settlements", es: "Acuerdos de Seguros" } },
  { value: "$2M+", label: { en: "In Fees Recovered", es: "En Honorarios Recuperados" } },
];

interface ProofBarProps {
  className?: string;
  compact?: boolean;
}

export function ProofBar({ className = "", compact = false }: ProofBarProps) {
  const { t } = useLocale();

  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 ${compact ? "gap-5" : "gap-6"} ${className}`}>
      {stats.map((stat, i) => (
        <div
          key={i}
          className={`relative text-center ${compact ? "py-6 px-5" : "py-8 px-6"} bg-card/40 border border-border/30 rounded-lg backdrop-blur-sm hover:shadow-xl hover:shadow-primary/5 transition-shadow`}
        >
          <p className={`font-serif font-bold text-primary ${compact ? "text-3xl md:text-4xl" : "text-4xl md:text-5xl"} tracking-tight mb-2`}>
            {stat.value}
          </p>
          <p className="text-base text-muted-foreground uppercase tracking-wider font-medium">
            {t(stat.label)}
          </p>
        </div>
      ))}
    </div>
  );
}
